import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function yearReducer(state = initialState.year, action: any) {
  switch (action.type) {
    case types.SAVE_YEAR_SUCCESS:
      return action.year;
    default:
      return state;
  }
}
